/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuFilterMatchingSets_itemSearch = {
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuMultiSelectList_itemSearch">;
    readonly " $refType": "SbSharedRefineMenuFilterMatchingSets_itemSearch";
};
export type SbSharedRefineMenuFilterMatchingSets_itemSearch$data = SbSharedRefineMenuFilterMatchingSets_itemSearch;
export type SbSharedRefineMenuFilterMatchingSets_itemSearch$key = {
    readonly " $data"?: SbSharedRefineMenuFilterMatchingSets_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuFilterMatchingSets_itemSearch">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRefineMenuFilterMatchingSets_itemSearch",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuMultiSelectList_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
(node as any).hash = '46ec47273c86b37f5ce41cb0d420a07d';
export default node;
